import * as THREE from 'three'
import { getBoundingSphere } from 'src/utils/boundings'

export const getDiameter = (object: THREE.Object3D | THREE.Geometry | THREE.Box3) => {
  let radius
  if (object instanceof THREE.Geometry) {
    object.computeBoundingSphere()
    radius = (object.boundingSphere as THREE.Sphere).radius
  } else if (object instanceof THREE.Box3) {
    const boundingSphere = new THREE.Sphere()
    object.getBoundingSphere(boundingSphere)
    radius = boundingSphere.radius
  } else {
    radius = getBoundingSphere(object).radius
  }
  if (radius !== Infinity) {
    return radius * 2
  }
  return 0
}
